import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const ApartmentFinderBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
  const setApartmentFinderActive = useStore(state => state.setApartmentFinderActive)

  const state = { apartmentFinderActive: apartmentFinderActive }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-finderzustand", 1000)
    if (role === "recipient") {
      socket.current.on("finderzustand", zustand => {
        setApartmentFinderActive(zustand.apartmentFinderActive)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("finderzustand", state)
    }
  }, [state, role, url])

  return null
}

ApartmentFinderBroadcaster.propTypes = {}

export default ApartmentFinderBroadcaster
